import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { fetcher } from 'util/Csrf'
import { onError } from 'apollo-link-error'
import EnvVars from 'util/EnvVars'

const link = ApolloLink.from([
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors)
      graphQLErrors.map(({ message, locations, path }) =>
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      )
    if (networkError) console.log(`[Network error]: ${networkError}`)
  }),
  new HttpLink({
    uri: `${EnvVars.API_URL}/pub`,
    credentials: 'include',
    fetch: fetcher,
  }),
])

const cache = new InMemoryCache()
const client = new ApolloClient({
  link: link,
  cache: cache,
})

export const PubClient = client
